"use strict";

var constructionWidget = function () {
  var $slider = null;
  var sliderInstance = null;
  var $slideCount = null;
  var sliderOptions = {
    fullscreen: {
      enabled: true,
      nativeFS: true
    },
    controlNavigation: 'thumbnails',
    autoScaleSlider: true,
    autoScaleSliderWidth: 960,
    autoScaleSliderHeight: 850,
    loop: false,
    imageScaleMode: 'fit-if-smaller',
    navigateByClick: true,
    numImagesToPreload: 2,
    arrowsNav: true,
    arrowsNavAutoHide: true,
    arrowsNavHideOnTouch: true,
    keyboardNavEnabled: true,
    fadeinLoadedSlide: true,
    globalCaption: false,
    globalCaptionInside: false,
    thumbs: {
      appendSpan: true,
      firstMargin: true,
      paddingBottom: 4
    }
  };
  var constructionWidgetParams = {
    data: []
  };

  function updateSlideCount() {
    $slideCount.html("".concat(sliderInstance.currSlideId + 1, " / ").concat(sliderInstance.numSlides));
  }

  function initGallery() {
    if (sliderInstance) {
      sliderInstance.destroy();
    }

    $slider = $('#ImageGallery').royalSlider(sliderOptions);
    sliderInstance = $slider.data('royalSlider');
    sliderInstance.ev.on('rsAfterSlideChange', updateSlideCount);
    $slideCount = $('<div class="rsSlideCount"></div>').appendTo($slider);
  }

  function selectPeriod() {
    var $stageDesc = $('#StageOfDevelopDescription');
    var $periodSelect = $('#PeriodSelect');
    var $gallery = $('.construction-gallery');
    var selectedVal = $periodSelect.val();

    if (selectedVal !== null && constructionWidgetParams.data.length) {
      var current = constructionWidgetParams.data[selectedVal];
      $stageDesc.html(current.Description);
      $('#ImageGallery').empty();
      current.ImagesUrl.forEach(function (url) {
        var $img = $('<img>').attr('src', "".concat(url)).addClass('rsTmb');
        var $link = $('<a>').data('rsbigimg', "".concat(url)).attr('href', "".concat(url)).addClass('rsImg');
        $link.append($img);
        $('#ImageGallery').append($link);
      });
      initGallery();
      $('#ImageGallery').show();
      $periodSelect.show();
      $gallery.show();
    } else {
      $stageDesc.addClass('-empty');
      $stageDesc.html('К сожалению, по данному объекту нет информации о ходе строительства');
      $periodSelect.hide();
      $gallery.hide();
    }
  }

  function bindHandlers() {
    $(document).on('change', '#PeriodSelect', selectPeriod);
  }

  function unbindHandlers() {
    $(document).off('change', '#PeriodSelect');
  }

  function initPeriodsSelect() {
    var $periodSelector = $('#PeriodSelect');
    constructionWidgetParams.data.forEach(function (a, i) {
      $periodSelector.append(new Option(a.Period, i, false, false));
    });

    if (constructionWidgetParams.data.length) {
      LKCommon.initSelectric($periodSelector);
    }
  }

  function setParams(constructionParams) {
    constructionParams.data = _.orderBy(constructionParams.data, function (item) {
      var period = item.Period.replace("Январь", "01 01").replace("Февраль", "01 02").replace("Март", "01 03").replace("Апрель", "01 04").replace("Май", "01 05").replace("Июнь", "01 06").replace("Июль", "01 07").replace("Август", "01 08").replace("Сентябрь", "01 09").replace("Октябрь", "01 10").replace("Ноябрь", "01 11").replace("Декабрь", "01 12");
      return Date.parse(period);
    }, 'desc');
    constructionWidgetParams = $.extend({}, constructionWidgetParams, constructionParams);
  }

  function init(constructionParams) {
    setParams(constructionParams);
    initPeriodsSelect();
    unbindHandlers();
    bindHandlers();
  }

  return {
    init: init,
    selectPeriod: selectPeriod,
    updateSlideCount: updateSlideCount
  };
}();